import { BaseSerializer } from './base.serializer'
import { HubCourse } from 'models/hub-course.model'
import { HubCourseTimetableSerializer } from 'serializers/hub-course-timetable.serializer'
import { HubCoursePremoderationSerializer } from 'serializers/hub-course-premoderation.serializer'
import { InfractionSerializer } from './infraction.serializer'
import { CenterProgramSerializer } from './center-program.serializer'

export class HubCourseSerializer extends BaseSerializer<HubCourse> {
  static SERIALIZABLE_ATTRIBUTES = [
    'id', 'name', 'centerProgramId', 'hubCourseTimetable', '_destroy', 'sharedCoursesIds', 
    'hubCoursePremoderation', 'position', 'infractionIds', 'virtualQueueEnabled', 'state',
    'registrationSmsId'
  ]

  static SERIALIZERS = {
    hubCourseTimetable: HubCourseTimetableSerializer,
    hubCoursePremoderation: HubCoursePremoderationSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    hubCourseTimetable: 'hubCourseTimetableAttributes',
    hubCoursePremoderation: 'hubCoursePremoderationAttributes'
  }


  static DESERIALIZERS = {
    hubCourseTimetable: HubCourseTimetableSerializer,
    hubCoursePremoderation: HubCoursePremoderationSerializer,
    centerProgram: CenterProgramSerializer,
    infractions: InfractionSerializer
  }
  static DESERIALIZE_RENAME_KEYS = {}


  static initializeObject(attributes: Object): HubCourse {
    return new HubCourse(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/hub-course.serializer.ts